import React, {useState} from 'react';
import {PlacementTest} from '../../../../graphql/API';
import {Typography} from 'antd';
import AnswerComponent from '../AnswerComponent';
import {CertificatesScoreTable} from './CertificatesScoreTable';

type PlacementTestReportProps = {
  placementTest: PlacementTest;
};
export const PlacementTestReport = ({
  placementTest,
}: PlacementTestReportProps) => {
  const {Title} = Typography;

  const [currentPlayingId, setCurrentPlayingId] = useState<string | null>(null);

  const handleAudioPlay = (answerId: string) => {
    if (currentPlayingId !== answerId) {
      setCurrentPlayingId(answerId);
    }
  };

  return (
    <div style={{marginRight: '60px', marginLeft: '60px'}}>
      <div style={{justifySelf: 'center'}}>
        <Title
          level={4}
          style={{
            marginTop: 20,
            fontWeight: 'normal',
            display: 'inline-block',
          }}>
          The placement test is{'  '}
        </Title>
        <Title
          level={4}
          style={{
            marginTop: 20,
            fontWeight: 'normal',
            display: 'inline-block',
            marginLeft: '3px',
            color: placementTest.isCompleted ? '#1890FF' : '#F2406A',
          }}>
          {placementTest.isCompleted
            ? 'Completed successfully'
            : 'not completed'}
        </Title>
      </div>
      <div style={{justifyItems: 'center'}}>
        <Title style={{marginTop: 50}}>Score</Title>
        <CertificatesScoreTable placementTest={placementTest} />
      </div>

      <div style={{width: '50%', justifySelf: 'center'}}>
        <Title style={{marginTop: 50, justifySelf: 'center'}}>Answers</Title>
        {placementTest?.answers?.map((answer, index) => {
          return (
            <AnswerComponent
              propAnswer={answer}
              key={index}
              answerId={answer?.id ?? ''}
              currentPlayingId={currentPlayingId}
              isPlaying={currentPlayingId === answer?.id}
              //@ts-ignore
              onPlay={() => handleAudioPlay(answer?.id)}
              index={index}
              stopAudioPlayback={false}
            />
          );
        })}
      </div>
    </div>
  );
};
